// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-time-picker-segment-input {
  display: block;
  position: relative;
}
.fi-time-picker-segment-input .overtime-message {
  margin: 0;
  position: absolute;
  bottom: -20px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-time-picker-input/fi-time-picker-segment-input/fi-time-picker-segment-input.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,kBAAA;AACJ;AACI;EACI,SAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AACR","sourcesContent":[".fi-time-picker-segment-input {\r\n    display: block;\r\n    position: relative;\r\n\r\n    .overtime-message {\r\n        margin: 0;\r\n        position: absolute;\r\n        bottom: -20px;\r\n        font-size: 12px;\r\n        font-weight: 400;\r\n        line-height: 16px;\r\n        letter-spacing: 0.4px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
